/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ShootsRouteImport } from './routes/shoots'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ReportsRouteImport } from './routes/reports'
import { Route as PortalRouteImport } from './routes/portal'
import { Route as LeadsRouteImport } from './routes/leads'
import { Route as InvoicesRouteImport } from './routes/invoices'
import { Route as GearRouteImport } from './routes/gear'
import { Route as GalleriesRouteImport } from './routes/galleries'
import { Route as EditingRouteImport } from './routes/editing'
import { Route as ContractsRouteImport } from './routes/contracts'
import { Route as ClientsRouteImport } from './routes/clients'
import { Route as BookingsRouteImport } from './routes/bookings'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PortalIndexRouteImport } from './routes/portal.index'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as PortalShootsRouteImport } from './routes/portal.shoots'
import { Route as PortalProfileRouteImport } from './routes/portal.profile'
import { Route as PortalLoginRouteImport } from './routes/portal.login'
import { Route as PortalInvoicesRouteImport } from './routes/portal.invoices'
import { Route as PortalGalleriesRouteImport } from './routes/portal.galleries'
import { Route as PortalContractsRouteImport } from './routes/portal.contracts'
import { Route as AdminUsersRouteImport } from './routes/admin.users'
import { Route as AdminPlansRouteImport } from './routes/admin.plans'
import { Route as AdminOrganizationsRouteImport } from './routes/admin.organizations'
import { Route as AdminLoginRouteImport } from './routes/admin.login'
import { Route as AdminFeatureFlagsRouteImport } from './routes/admin.feature-flags'
import { Route as AdminBillingRouteImport } from './routes/admin.billing'
import { Route as AdminAuditRouteImport } from './routes/admin.audit'
import { Route as AdminAnnouncementsRouteImport } from './routes/admin.announcements'
import { Route as AdminOrganizationsIdRouteImport } from './routes/admin.organizations.$id'

const ShootsRoute = ShootsRouteImport.update({
  id: '/shoots',
  path: '/shoots',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsRoute = ReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalRoute = PortalRouteImport.update({
  id: '/portal',
  path: '/portal',
  getParentRoute: () => rootRouteImport,
} as any)
const LeadsRoute = LeadsRouteImport.update({
  id: '/leads',
  path: '/leads',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoicesRoute = InvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => rootRouteImport,
} as any)
const GearRoute = GearRouteImport.update({
  id: '/gear',
  path: '/gear',
  getParentRoute: () => rootRouteImport,
} as any)
const GalleriesRoute = GalleriesRouteImport.update({
  id: '/galleries',
  path: '/galleries',
  getParentRoute: () => rootRouteImport,
} as any)
const EditingRoute = EditingRouteImport.update({
  id: '/editing',
  path: '/editing',
  getParentRoute: () => rootRouteImport,
} as any)
const ContractsRoute = ContractsRouteImport.update({
  id: '/contracts',
  path: '/contracts',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientsRoute = ClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => rootRouteImport,
} as any)
const BookingsRoute = BookingsRouteImport.update({
  id: '/bookings',
  path: '/bookings',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalIndexRoute = PortalIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PortalRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const PortalShootsRoute = PortalShootsRouteImport.update({
  id: '/shoots',
  path: '/shoots',
  getParentRoute: () => PortalRoute,
} as any)
const PortalProfileRoute = PortalProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => PortalRoute,
} as any)
const PortalLoginRoute = PortalLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PortalRoute,
} as any)
const PortalInvoicesRoute = PortalInvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => PortalRoute,
} as any)
const PortalGalleriesRoute = PortalGalleriesRouteImport.update({
  id: '/galleries',
  path: '/galleries',
  getParentRoute: () => PortalRoute,
} as any)
const PortalContractsRoute = PortalContractsRouteImport.update({
  id: '/contracts',
  path: '/contracts',
  getParentRoute: () => PortalRoute,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPlansRoute = AdminPlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOrganizationsRoute = AdminOrganizationsRouteImport.update({
  id: '/organizations',
  path: '/organizations',
  getParentRoute: () => AdminRoute,
} as any)
const AdminLoginRoute = AdminLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AdminRoute,
} as any)
const AdminFeatureFlagsRoute = AdminFeatureFlagsRouteImport.update({
  id: '/feature-flags',
  path: '/feature-flags',
  getParentRoute: () => AdminRoute,
} as any)
const AdminBillingRoute = AdminBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAuditRoute = AdminAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAnnouncementsRoute = AdminAnnouncementsRouteImport.update({
  id: '/announcements',
  path: '/announcements',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOrganizationsIdRoute = AdminOrganizationsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdminOrganizationsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/auth': typeof AuthRoute
  '/bookings': typeof BookingsRoute
  '/clients': typeof ClientsRoute
  '/contracts': typeof ContractsRoute
  '/editing': typeof EditingRoute
  '/galleries': typeof GalleriesRoute
  '/gear': typeof GearRoute
  '/invoices': typeof InvoicesRoute
  '/leads': typeof LeadsRoute
  '/portal': typeof PortalRouteWithChildren
  '/reports': typeof ReportsRoute
  '/settings': typeof SettingsRoute
  '/shoots': typeof ShootsRoute
  '/admin/announcements': typeof AdminAnnouncementsRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/billing': typeof AdminBillingRoute
  '/admin/feature-flags': typeof AdminFeatureFlagsRoute
  '/admin/login': typeof AdminLoginRoute
  '/admin/organizations': typeof AdminOrganizationsRouteWithChildren
  '/admin/plans': typeof AdminPlansRoute
  '/admin/users': typeof AdminUsersRoute
  '/portal/contracts': typeof PortalContractsRoute
  '/portal/galleries': typeof PortalGalleriesRoute
  '/portal/invoices': typeof PortalInvoicesRoute
  '/portal/login': typeof PortalLoginRoute
  '/portal/profile': typeof PortalProfileRoute
  '/portal/shoots': typeof PortalShootsRoute
  '/admin/': typeof AdminIndexRoute
  '/portal/': typeof PortalIndexRoute
  '/admin/organizations/$id': typeof AdminOrganizationsIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth': typeof AuthRoute
  '/bookings': typeof BookingsRoute
  '/clients': typeof ClientsRoute
  '/contracts': typeof ContractsRoute
  '/editing': typeof EditingRoute
  '/galleries': typeof GalleriesRoute
  '/gear': typeof GearRoute
  '/invoices': typeof InvoicesRoute
  '/leads': typeof LeadsRoute
  '/reports': typeof ReportsRoute
  '/settings': typeof SettingsRoute
  '/shoots': typeof ShootsRoute
  '/admin/announcements': typeof AdminAnnouncementsRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/billing': typeof AdminBillingRoute
  '/admin/feature-flags': typeof AdminFeatureFlagsRoute
  '/admin/login': typeof AdminLoginRoute
  '/admin/organizations': typeof AdminOrganizationsRouteWithChildren
  '/admin/plans': typeof AdminPlansRoute
  '/admin/users': typeof AdminUsersRoute
  '/portal/contracts': typeof PortalContractsRoute
  '/portal/galleries': typeof PortalGalleriesRoute
  '/portal/invoices': typeof PortalInvoicesRoute
  '/portal/login': typeof PortalLoginRoute
  '/portal/profile': typeof PortalProfileRoute
  '/portal/shoots': typeof PortalShootsRoute
  '/admin': typeof AdminIndexRoute
  '/portal': typeof PortalIndexRoute
  '/admin/organizations/$id': typeof AdminOrganizationsIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/auth': typeof AuthRoute
  '/bookings': typeof BookingsRoute
  '/clients': typeof ClientsRoute
  '/contracts': typeof ContractsRoute
  '/editing': typeof EditingRoute
  '/galleries': typeof GalleriesRoute
  '/gear': typeof GearRoute
  '/invoices': typeof InvoicesRoute
  '/leads': typeof LeadsRoute
  '/portal': typeof PortalRouteWithChildren
  '/reports': typeof ReportsRoute
  '/settings': typeof SettingsRoute
  '/shoots': typeof ShootsRoute
  '/admin/announcements': typeof AdminAnnouncementsRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/billing': typeof AdminBillingRoute
  '/admin/feature-flags': typeof AdminFeatureFlagsRoute
  '/admin/login': typeof AdminLoginRoute
  '/admin/organizations': typeof AdminOrganizationsRouteWithChildren
  '/admin/plans': typeof AdminPlansRoute
  '/admin/users': typeof AdminUsersRoute
  '/portal/contracts': typeof PortalContractsRoute
  '/portal/galleries': typeof PortalGalleriesRoute
  '/portal/invoices': typeof PortalInvoicesRoute
  '/portal/login': typeof PortalLoginRoute
  '/portal/profile': typeof PortalProfileRoute
  '/portal/shoots': typeof PortalShootsRoute
  '/admin/': typeof AdminIndexRoute
  '/portal/': typeof PortalIndexRoute
  '/admin/organizations/$id': typeof AdminOrganizationsIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/auth'
    | '/bookings'
    | '/clients'
    | '/contracts'
    | '/editing'
    | '/galleries'
    | '/gear'
    | '/invoices'
    | '/leads'
    | '/portal'
    | '/reports'
    | '/settings'
    | '/shoots'
    | '/admin/announcements'
    | '/admin/audit'
    | '/admin/billing'
    | '/admin/feature-flags'
    | '/admin/login'
    | '/admin/organizations'
    | '/admin/plans'
    | '/admin/users'
    | '/portal/contracts'
    | '/portal/galleries'
    | '/portal/invoices'
    | '/portal/login'
    | '/portal/profile'
    | '/portal/shoots'
    | '/admin/'
    | '/portal/'
    | '/admin/organizations/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/bookings'
    | '/clients'
    | '/contracts'
    | '/editing'
    | '/galleries'
    | '/gear'
    | '/invoices'
    | '/leads'
    | '/reports'
    | '/settings'
    | '/shoots'
    | '/admin/announcements'
    | '/admin/audit'
    | '/admin/billing'
    | '/admin/feature-flags'
    | '/admin/login'
    | '/admin/organizations'
    | '/admin/plans'
    | '/admin/users'
    | '/portal/contracts'
    | '/portal/galleries'
    | '/portal/invoices'
    | '/portal/login'
    | '/portal/profile'
    | '/portal/shoots'
    | '/admin'
    | '/portal'
    | '/admin/organizations/$id'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/auth'
    | '/bookings'
    | '/clients'
    | '/contracts'
    | '/editing'
    | '/galleries'
    | '/gear'
    | '/invoices'
    | '/leads'
    | '/portal'
    | '/reports'
    | '/settings'
    | '/shoots'
    | '/admin/announcements'
    | '/admin/audit'
    | '/admin/billing'
    | '/admin/feature-flags'
    | '/admin/login'
    | '/admin/organizations'
    | '/admin/plans'
    | '/admin/users'
    | '/portal/contracts'
    | '/portal/galleries'
    | '/portal/invoices'
    | '/portal/login'
    | '/portal/profile'
    | '/portal/shoots'
    | '/admin/'
    | '/portal/'
    | '/admin/organizations/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  AuthRoute: typeof AuthRoute
  BookingsRoute: typeof BookingsRoute
  ClientsRoute: typeof ClientsRoute
  ContractsRoute: typeof ContractsRoute
  EditingRoute: typeof EditingRoute
  GalleriesRoute: typeof GalleriesRoute
  GearRoute: typeof GearRoute
  InvoicesRoute: typeof InvoicesRoute
  LeadsRoute: typeof LeadsRoute
  PortalRoute: typeof PortalRouteWithChildren
  ReportsRoute: typeof ReportsRoute
  SettingsRoute: typeof SettingsRoute
  ShootsRoute: typeof ShootsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/shoots': {
      id: '/shoots'
      path: '/shoots'
      fullPath: '/shoots'
      preLoaderRoute: typeof ShootsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports': {
      id: '/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof ReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal': {
      id: '/portal'
      path: '/portal'
      fullPath: '/portal'
      preLoaderRoute: typeof PortalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/leads': {
      id: '/leads'
      path: '/leads'
      fullPath: '/leads'
      preLoaderRoute: typeof LeadsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices': {
      id: '/invoices'
      path: '/invoices'
      fullPath: '/invoices'
      preLoaderRoute: typeof InvoicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gear': {
      id: '/gear'
      path: '/gear'
      fullPath: '/gear'
      preLoaderRoute: typeof GearRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/galleries': {
      id: '/galleries'
      path: '/galleries'
      fullPath: '/galleries'
      preLoaderRoute: typeof GalleriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/editing': {
      id: '/editing'
      path: '/editing'
      fullPath: '/editing'
      preLoaderRoute: typeof EditingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contracts': {
      id: '/contracts'
      path: '/contracts'
      fullPath: '/contracts'
      preLoaderRoute: typeof ContractsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients': {
      id: '/clients'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof ClientsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bookings': {
      id: '/bookings'
      path: '/bookings'
      fullPath: '/bookings'
      preLoaderRoute: typeof BookingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/': {
      id: '/portal/'
      path: '/'
      fullPath: '/portal/'
      preLoaderRoute: typeof PortalIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/portal/shoots': {
      id: '/portal/shoots'
      path: '/shoots'
      fullPath: '/portal/shoots'
      preLoaderRoute: typeof PortalShootsRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/profile': {
      id: '/portal/profile'
      path: '/profile'
      fullPath: '/portal/profile'
      preLoaderRoute: typeof PortalProfileRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/login': {
      id: '/portal/login'
      path: '/login'
      fullPath: '/portal/login'
      preLoaderRoute: typeof PortalLoginRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/invoices': {
      id: '/portal/invoices'
      path: '/invoices'
      fullPath: '/portal/invoices'
      preLoaderRoute: typeof PortalInvoicesRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/galleries': {
      id: '/portal/galleries'
      path: '/galleries'
      fullPath: '/portal/galleries'
      preLoaderRoute: typeof PortalGalleriesRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/contracts': {
      id: '/portal/contracts'
      path: '/contracts'
      fullPath: '/portal/contracts'
      preLoaderRoute: typeof PortalContractsRouteImport
      parentRoute: typeof PortalRoute
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/plans': {
      id: '/admin/plans'
      path: '/plans'
      fullPath: '/admin/plans'
      preLoaderRoute: typeof AdminPlansRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/organizations': {
      id: '/admin/organizations'
      path: '/organizations'
      fullPath: '/admin/organizations'
      preLoaderRoute: typeof AdminOrganizationsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/login': {
      id: '/admin/login'
      path: '/login'
      fullPath: '/admin/login'
      preLoaderRoute: typeof AdminLoginRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/feature-flags': {
      id: '/admin/feature-flags'
      path: '/feature-flags'
      fullPath: '/admin/feature-flags'
      preLoaderRoute: typeof AdminFeatureFlagsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/billing': {
      id: '/admin/billing'
      path: '/billing'
      fullPath: '/admin/billing'
      preLoaderRoute: typeof AdminBillingRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/audit': {
      id: '/admin/audit'
      path: '/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AdminAuditRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/announcements': {
      id: '/admin/announcements'
      path: '/announcements'
      fullPath: '/admin/announcements'
      preLoaderRoute: typeof AdminAnnouncementsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/organizations/$id': {
      id: '/admin/organizations/$id'
      path: '/$id'
      fullPath: '/admin/organizations/$id'
      preLoaderRoute: typeof AdminOrganizationsIdRouteImport
      parentRoute: typeof AdminOrganizationsRoute
    }
  }
}

interface AdminOrganizationsRouteChildren {
  AdminOrganizationsIdRoute: typeof AdminOrganizationsIdRoute
}

const AdminOrganizationsRouteChildren: AdminOrganizationsRouteChildren = {
  AdminOrganizationsIdRoute: AdminOrganizationsIdRoute,
}

const AdminOrganizationsRouteWithChildren =
  AdminOrganizationsRoute._addFileChildren(AdminOrganizationsRouteChildren)

interface AdminRouteChildren {
  AdminAnnouncementsRoute: typeof AdminAnnouncementsRoute
  AdminAuditRoute: typeof AdminAuditRoute
  AdminBillingRoute: typeof AdminBillingRoute
  AdminFeatureFlagsRoute: typeof AdminFeatureFlagsRoute
  AdminLoginRoute: typeof AdminLoginRoute
  AdminOrganizationsRoute: typeof AdminOrganizationsRouteWithChildren
  AdminPlansRoute: typeof AdminPlansRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAnnouncementsRoute: AdminAnnouncementsRoute,
  AdminAuditRoute: AdminAuditRoute,
  AdminBillingRoute: AdminBillingRoute,
  AdminFeatureFlagsRoute: AdminFeatureFlagsRoute,
  AdminLoginRoute: AdminLoginRoute,
  AdminOrganizationsRoute: AdminOrganizationsRouteWithChildren,
  AdminPlansRoute: AdminPlansRoute,
  AdminUsersRoute: AdminUsersRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface PortalRouteChildren {
  PortalContractsRoute: typeof PortalContractsRoute
  PortalGalleriesRoute: typeof PortalGalleriesRoute
  PortalInvoicesRoute: typeof PortalInvoicesRoute
  PortalLoginRoute: typeof PortalLoginRoute
  PortalProfileRoute: typeof PortalProfileRoute
  PortalShootsRoute: typeof PortalShootsRoute
  PortalIndexRoute: typeof PortalIndexRoute
}

const PortalRouteChildren: PortalRouteChildren = {
  PortalContractsRoute: PortalContractsRoute,
  PortalGalleriesRoute: PortalGalleriesRoute,
  PortalInvoicesRoute: PortalInvoicesRoute,
  PortalLoginRoute: PortalLoginRoute,
  PortalProfileRoute: PortalProfileRoute,
  PortalShootsRoute: PortalShootsRoute,
  PortalIndexRoute: PortalIndexRoute,
}

const PortalRouteWithChildren =
  PortalRoute._addFileChildren(PortalRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  AuthRoute: AuthRoute,
  BookingsRoute: BookingsRoute,
  ClientsRoute: ClientsRoute,
  ContractsRoute: ContractsRoute,
  EditingRoute: EditingRoute,
  GalleriesRoute: GalleriesRoute,
  GearRoute: GearRoute,
  InvoicesRoute: InvoicesRoute,
  LeadsRoute: LeadsRoute,
  PortalRoute: PortalRouteWithChildren,
  ReportsRoute: ReportsRoute,
  SettingsRoute: SettingsRoute,
  ShootsRoute: ShootsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
